import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from 'api/axios';
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const PanelModal = ({ open, onClose, data }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    bgcolor: "background.paper",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
  };

  const [_id, setID] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("ACTIVE");
  const [module, setModule] = useState("OPD");
  const [schemeType, setSchemeType] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const enableBtn = () => setDisabled(false);

  // Prefill on edit
  useEffect(() => {
    if (data && Object.entries(data).length > 0) {
      setID(data?._id || "");
      setName(data?.name || "");
      setStatus(data?.status || "ACTIVE");
      setModule(data?.module || "OPD");
      setSchemeType(data?.schemeType || "");
    }
  }, []);

  const handleSubmit = () => {
    try {
      if (!name.trim()) {
        toast.error("Panel Name required hai!");
        return;
      }

      setIsApiLoading(true);

      const payload = {
        name: name.trim(),
        status,
        module,
        schemeType: schemeType || null,
      };

      if (_id) {
        api
          .patch(`/admin-panel/${_id}`, payload)
          .then(() => {
            setIsApiLoading(false);
            onClose();
            toast.success("Panel Updated Successfully!");
          })
          .catch((err) => {
            setIsApiLoading(false);
            toast.error(err?.response?.data?.message || "Update failed!");
          });
      } else {
        api
          .post(`/admin-panel/`, payload)
          .then(() => {
            setIsApiLoading(false);
            onClose();
            toast.success("Panel Added Successfully!");
          })
          .catch((err) => {
            setIsApiLoading(false);
            onClose("close");
            toast.error(err?.response?.data?.message || "Add failed!");
          });
      }
    } catch (err) {
      setIsApiLoading(false);
      onClose("close");
      toast.error(`Failed to ${_id ? "update" : "add"} Panel!`);
    }
  };

  const handleDelete = () => {
    api
      .delete(`/admin-panel/${_id}`)
      .then(() => {
        onClose();
        toast.success("Panel Deleted Successfully!");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Delete failed!");
      });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => onClose("close")}
        aria-labelledby="panel-modal-title"
      >
        <Box sx={style}>
          {/* Header */}
          <Grid
            container
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 3 }}
          >
            <Typography variant="h5" component="h5">
              {_id ? "Edit Panel" : "Add Panel"}
            </Typography>

            {/* Delete Button — sirf edit mein */}
            {_id && (
              <Box
                onClick={() => setDeleteModal(true)}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "30px",
                  height: "30px",
                  bgcolor: "#FFE6F0",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                <svg width={25} height={25} viewBox="0 0 25 25" fill="none">
                  <path d="M10.4941 12.5V17.5" stroke="#F51934" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.4941 12.5V17.5" stroke="#F51934" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4.49414 7.5H20.4941" stroke="#F51934" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M6.49414 10.5V18.5C6.49414 20.1569 7.83729 21.5 9.49414 21.5H15.4941C17.151 21.5 18.4941 20.1569 18.4941 18.5V10.5" stroke="#F51934" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.49414 5.5C9.49414 4.39543 10.3896 3.5 11.4941 3.5H13.4941C14.5987 3.5 15.4941 4.39543 15.4941 5.5V7.5H9.49414V5.5Z" stroke="#F51934" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Box>
            )}
          </Grid>

          {/* Form */}
          <Grid container spacing={3}>
            {/* Panel Name */}
            <Grid item sm={12} lg={12} md={12}>
              <TextField
                fullWidth
                type="text"
                label="Panel Name"
                value={name}
                onChange={(e) => {
                  enableBtn();
                  setName(e.target.value);
                }}
                size="small"
              />
            </Grid>
            {/* Module */}
            <Grid item sm={12} lg={12} md={12}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Module</InputLabel>
                <Select
                  value={module}
                  label="Module"
                  onChange={(e) => {
                    enableBtn();
                    setModule(e.target.value);
                  }}
                >
                  <MenuItem value="OPD">OPD</MenuItem>
                  <MenuItem value="IPD">IPD</MenuItem>
                  <MenuItem value="BOTH">BOTH</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Scheme Type */}
            <Grid item sm={12} lg={12} md={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Scheme Type</InputLabel>
                <Select
                  value={schemeType}
                  label="Scheme Type"
                  onChange={(e) => {
                    enableBtn();
                    setSchemeType(e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="CGHS">CGHS</MenuItem>
                  <MenuItem value="PMJAY">PMJAY</MenuItem>
                  <MenuItem value="ECHS">ECHS</MenuItem>
                  <MenuItem value="OTHER">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Status */}
            <Grid item sm={12} lg={12} md={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => {
                    enableBtn();
                    setStatus(e.target.value);
                  }}
                >
                  <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                  <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Footer Buttons */}
          <Grid
            item
            sm={12}
            display="flex"
            justifyContent="right"
            sx={{ mt: 3 }}
          >
            <Button
              sx={{
                marginRight: "15px",
                bgcolor: "white",
                border: "1px solid #194AF5",
                color: "#194AF5",
                padding: "0.25rem 1.5rem",
                boxShadow: "none",
                ":hover": {
                  bgcolor: "white",
                  border: "1px solid #194AF5",
                  boxShadow: "none",
                },
              }}
              variant="contained"
              onClick={() => onClose("close")}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={disabled || isApiLoading}
              onClick={handleSubmit}
              sx={{ padding: "0.25rem 1.5rem", boxShadow: "none" }}
            >
              {isApiLoading ? "Saving..." : "Save"}
            </Button>
          </Grid>

          {/* Delete Confirm */}
          <ConfirmModal
            open={deleteModal}
            type="panel"
            close={() => setDeleteModal(false)}
            confirm={() => {
              handleDelete();
              setDeleteModal(false);
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default PanelModal;